'use client'

import {SanityImageType} from '@local/types'
import {SanityImage, Pastil} from '@local/ui/components'
import {cx} from '@local/utils/cx'
import {forwardRef, ForwardedRef, useState} from 'react'
export interface ProductFacilitiesCardProps {
	facility?: string;
	description?: string;
	image: SanityImageType;
}

export const ProductFacilitiesCard = forwardRef(
	(
		{facility, description, image}: ProductFacilitiesCardProps,
		ref: ForwardedRef<HTMLElement>,
	) => {
		const [isHovered, setIsHovered] = useState<boolean>(false)
		return (
			<figure
				ref={ref}
				className='relative lg-max:aspect-[294/400] span-w-10 lg:span-w-4 group'>
				<SanityImage
					image={image}
					width={453}
					height={567}
					desktopWidth={453}
					mobileWidth={294}
					className='w-full h-full object-cover lg-max:aspect-[294/400]' />
				{description && !!description.trim() && (
					<div
						onClick={() => setIsHovered(false)}
						className={cx(
							'absolute inset-0 bg-grey-2 p-20 pb-40 z-1 flex items-center',
							'transition-[opacity,visibility] duration-300 ease-quart-out',
							'group-hover:opacity-100 group-hover:visible group-hover:ease-expo-out',
							isHovered
								? 'opacity-100 visible ease-expo-out'
								: 'opacity-0 invisible',
						)}>
						<p className='text-12 lg:text-14 text-white tracking-tight leading-moderate font-book'>
							{description}
						</p>
					</div>
				)}

				{facility && !!facility.trim() && (
					<Pastil
						variant='grey'
						className={cx(
							'z-2 absolute bottom-20 left-1/2 lg-max:-translate-x-1/2 w-max max-w-[90%]',
							'lg:bottom-30 lg:left-30',
						)}>
						{facility}
					</Pastil>
				)}
			</figure>
		)
	},
)
